import chipStatusColor from './chipStatusColor'
import statusLabel from './statusLabel'

const redirectLinks = {
  chipStatusColor,
  statusLabel,
}

export default redirectLinks
